import React from 'react';

const SessionProvider = ({ children }) => children;

export default React.memo(SessionProvider);
